
<div class="p-4 text-white bg-primary">
    <h2 class="uppercase font-bold">
        viesti
    </h2>
</div>

<div class="p-4 space-y-2">
    {{
        data.translate
            ? ( data.message | translate )
            : data.message
    }}
</div>

<div class="p-4">
    <button type="submit" class="w-min px-3 py-1 bg-secondary text-white font-bold rounded float-end" (click)="dialogRef.close()" > {{ "GLOBAL.CLOSE" | translate }} </button>
</div>